import axios from 'axios';
import apiZelo from '../backAxiosVendaToken';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

const apiIBGE = axios.create({
    baseURL: retornoHashValor(process.env.REACT_APP_9)
});

class CidadesEstadosService {
    async getEstadosBrasil() {
        return (await apiIBGE.get('localidades/estados')).data;
    }

    async getCidadesEstado(estado) {
        return (await apiIBGE.get(`localidades/estados/${estado}/municipios`)).data;
    }

    async getPlanos() {
        return (await apiZelo.get('/associados/busca-preco-uf/todos')).data;
    }

    async postPlanos(planos) {
        return (await apiZelo.post('/tabela-preco/cadastro-edicao-por-lote', planos)).data;
    }

    async postAgendamento(planos) {
        return (await apiZelo.post('/adesao-por-cidade/agendamento', planos)).data;
    }
}

export default new CidadesEstadosService();
